import React from 'react';
import { Button } from '@mui/material';
import ShareIcon from '@mui/icons-material/Share';
import { tracking } from '../../../../utils/tracking';
import { trackDirect } from '../../../../store/analytics/api';
import { STUDIO_TRACKING_SOURCE } from '../../Tools/hotTopicStudio/utils/studioTracking';
import { newsToStudioPack } from '../studio/newsToStudioPack';

interface CustomizeHotTopicButtonProps {
  news: any;
  intl: any;
  history?: any;
  newsfeedId?: string | number;
  /** `list` sits inline after the title on the newsfeed index. */
  appearance?: 'detail' | 'list';
}

const CustomizeHotTopicButton: React.FC<CustomizeHotTopicButtonProps> = ({
  news,
  intl,
  history,
  newsfeedId,
  appearance = 'detail'
}) => {
  const isList = appearance === 'list';
  const studioItem = newsToStudioPack(news);
  const newsId = (studioItem && studioItem.id) || news?.news_id || news?.id;

  if ((!studioItem && !isList) || !history || newsfeedId == null || newsId == null) {
    return null;
  }

  const onClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    event.preventDefault();
    tracking('Click on Selected Newsfeed - Enter Studio', {
      newsId,
      newsfeedId,
      source: STUDIO_TRACKING_SOURCE.CUSTOM_NEWSFEED,
      entry: isList ? 'newsfeed-list' : 'newsfeed-detail'
    });
    trackDirect('useCustomNewsfeed', String(newsId));
    trackDirect('useSelectedNewsfeed');
    history.push(
      `/selected_newsfeed/${newsfeedId}/studio/${encodeURIComponent(String(newsId))}`,
      studioItem ? { studioItem } : undefined
    );
  };

  return (
    <Button
      variant="contained"
      color="primary"
      startIcon={<ShareIcon />}
      onClick={onClick}
      sx={
        isList
          ? {
              textTransform: 'none',
              fontSize: '1.2rem',
              fontWeight: 600,
              lineHeight: 1,
              margin: '0.15rem 0 0',
              minWidth: 'auto',
              minHeight: '2.6rem',
              height: '2.6rem',
              borderRadius: '0.5rem',
              flexShrink: 0,
              alignSelf: 'center',
              whiteSpace: 'nowrap',
              boxShadow: 'none',
              py: 0,
              px: '0.7rem',
              '&:hover': { boxShadow: 'none' },
              '& .MuiButton-startIcon': { marginRight: '0.3rem', marginLeft: '-0.1rem' },
              '& .MuiButton-startIcon > svg': { fontSize: '1.3rem' }
            }
          : {
              textTransform: 'none',
              fontSize: '1.3rem',
              margin: 0,
              flexShrink: 0,
              whiteSpace: 'nowrap',
              py: 0.5,
              px: 1.5
            }
      }
    >
      {intl.formatMessage({ id: 'selected-newsfeed-customize-hot-topic' })}
    </Button>
  );
};

export default CustomizeHotTopicButton;
